<div class="password-validation-step-row-container">
    @if (isDirty()) {
        <span class="rule-icon">
            <mat-icon [ngClass]="error() ? 'danger' : 'success'" [@iconAnimation]="error() ? 'close' : 'check'">{{ error() ? 'close' : 'check' }}</mat-icon>
        </span>
    } @else {
        <span class="idle-icon"></span>
    }
    <span class="rule-text">{{ validationMessage() }}</span>
</div>
